import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';
import K2TN from './k2TN';
import FDTN from './fdTN';

function DTTN({initiallyDisableKeypress}) {
  const [value, setValue] = useState(10);
  const {setDisableMenu, onComponent} = useContext(MenuContext);

  const onRightHold = useCallback(() => {
    setDisableMenu(true);
    onComponent(<FDTN initiallyDisableKeypress />);
    setTimeout(() => setDisableMenu(false), 500);
  }, [value]);

  return (
    <NumberView
      chars={numbers}
      focus={8}
      onChange={v => setValue(v)}
      defaultKey1={2}
      defaultKey2={2}
      defaultKey3={2}
      defaultKey4={2}
      defaultKey5={2}
      defaultKey6={2}
      defaultKey7={2}
      defaultKey8={6}
      defaultKey9={12}
      defaultKey10={6}
      defaultKey11={6}
      defaultKey12={2}
      onSave={onRightHold}
      onLeftHold={() => onComponent(<K2TN />)}
      title="Set DT or TC"
      caption="Enter DT or TC from Sensor Tag:"
      left="Hold to Cancel"
      right="Hold to Save"
      initiallyDisableKeypress={initiallyDisableKeypress}
    />
  );
}

export default DTTN;
